module.exports = __webpack_public_path__ + "static/media/testoman.3d8cdb9a.png";